import { ArrowRight } from "lucide-react";

import { Card, CardContent } from "@krea/shared/design-system/Card";
import { cn } from "@krea/shared/utils";

import { countryCodeToName } from "@/features/common/constants";

import type { ILenderCompany } from "../api";

interface IProps {
  company: ILenderCompany;
  onSelect: (companyId: number) => void;
  disabled?: boolean;
}

export const CompanyCard = ({
  company,
  onSelect,
  disabled = false,
}: IProps) => {
  return (
    <Card
      role="button"
      tabIndex={0}
      onClick={() => !disabled && onSelect(company.id)}
      onKeyDown={(e) => {
        if (!disabled && (e.key === "Enter" || e.key === " "))
          onSelect(company.id);
      }}
      className={cn(
        "rounded-xl border-2 border-gray-200 bg-white transition-all duration-200 px-4 gap-2",
        "hover:border-primary hover:shadow-lg",
        "group cursor-pointer",
        disabled && "opacity-60 pointer-events-none",
      )}
    >
      <CardContent className="flex items-center justify-between px-1">
        <div className="flex items-center gap-3">
          {company.imageUrl && (
            <div className="flex items-start justify-between">
              <img
                src={company.imageUrl}
                alt={company.name}
                className="h-14 w-14 object-contain"
              />
            </div>
          )}
          <div>
            <h3 className="mb-1 text-section transition-colors group-hover:text-primary">
              {company.name}
            </h3>
            <span className="mb-4 text-helper">
              {countryCodeToName[company.countryCode]}
            </span>
          </div>
        </div>

        <ArrowRight
          className="h-4 w-4 text-primary opacity-0 transition-opacity group-hover:opacity-100"
          strokeWidth={4}
        />
      </CardContent>
    </Card>
  );
};
